// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"553829e5","488":"00093424","977":"1aa10f3e"}[chunkId] + ".chunk.js";
};